import { PaginatedPackSamples } from './pack.gql';

const packQueries = (guid?: string) => ({
    samples: {
        query: PaginatedPackSamples,
        pathToItems: 'paginatedPackSamples',
        pathToTotalItems: 'totalSampleRecords',
        skip: !guid,
        variables: {
            packGuid: guid,
        },
    },
    packs: undefined,
});

export default packQueries;
